export const PATTERNS = [
  { id: 'puntos', src: require('@/assets/iconsback/puntos.svg'), alt: 'Puntos' },
  { id: 'calaberas', src: require('@/assets/iconsback/calaberas.svg'), alt: 'Calaberas' },
  { id: 'calavazas', src: require('@/assets/iconsback/calavazas.svg'), alt: 'Calavazas' },
  { id: 'corazones', src: require('@/assets/iconsback/corazones.svg'), alt: 'Corazones' },
  { id: 'cuadros', src: require('@/assets/iconsback/cuadros.svg'), alt: 'Cuadros' },
  { id: 'flor', src: require('@/assets/iconsback/flor.svg'), alt: 'Flor' },
  { id: 'flor2', src: require('@/assets/iconsback/flor2.svg'), alt: 'Flor 2' },
  { id: 'happyface', src: require('@/assets/iconsback/happyface.svg'), alt: 'Happy Face' },
  { id: 'ondas', src: require('@/assets/iconsback/ondas.svg'), alt: 'Ondas' },
  { id: 'lunas', src: require('@/assets/iconsback/lunas.svg'), alt: 'Lunas' },
  { id: 'estrellas', src: require('@/assets/iconsback/estrellas.svg'), alt: 'Estrellas' },
  { id: 'play', src: require('@/assets/iconsback/play.svg'), alt: 'Play' },
  { id: 'lips', src: require('@/assets/iconsback/lip.png'), alt: 'Lips' },
  { id: 'aliens', src: require('@/assets/iconsback/alien.png'), alt: 'Aliens' },
  { id: 'copos', src: require('@/assets/iconsback/copo.png'), alt: 'Copos' },
  { id: 'navidad', src: require('@/assets/iconsback/navidad.png'), alt: 'Navidad' },
  { id: 'waves', src: require('@/assets/iconsback/wave.png'), alt: 'Waves' },
  { id: 'figures', src: require('@/assets/iconsback/figure.png'), alt: 'Figures' },
  { id: 'craneos', src: require('@/assets/iconsback/craneo.png'), alt: 'Craneos' },
  { id: 'masks', src: require('@/assets/iconsback/mask.png'), alt: 'Masks' }
];